import { productDataService } from 'services/products.service';

type OrderProduct = {
  currentColor: string;
  productId: string;
  mainFabricCode: string;
  productCode: string;
  orderNumber: string;
  userAlias: string;
};

export const finalisePathToDetailsData = async (
  { productId, mainFabricCode, currentColor, productCode }: OrderProduct,
  { season, zone, warehouse }: SettingsState
) => {
  const products = await productDataService.getProductInfoForOrder({
    itemCode: productCode,
    itemColorCode: currentColor,
    mainFabricCode,
    season,

    warehouse: warehouse.code,
    zone,
  });
  const product = products.data;

  return {
    gender: product.gender,
    category: product.category,
    id: productId,
    itemCode: productCode,
    mainFabricCode,
    itemColorCode: currentColor,
    genderCodeAndGenderDesc: product.genderCodeAndGenderDesc,
    styleCodeAndStyleDesc: product.styleCodeAndStyleDesc,
  };
};

interface SettingsState {
  season: string;
  marketLine: string;
  warehouse: {
    id: string;
    code: string;
    name: string;
  };
  zone: string;
}
